import { Dimension } from '../types/Dimension'

const dimensionEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/accounting/dimensions` as const,
  detail: (companyId: string, dimensionId: Dimension['dimensionId']) =>
    `/companies/${companyId}/accounting/dimensions/${dimensionId}` as const,
  defaultDimension: (companyId: string, dimensionId: Dimension['dimensionId']) =>
    `/companies/${companyId}/accounting/dimensions/default/${dimensionId}` as const,
  undo: (companyId: string) => `/companies/${companyId}/undo/dimensions` as const,
  latest: (companyId: string) => `/companies/${companyId}/undo/dimensions/latest` as const
}

export default dimensionEndpoints
